import { useNavigate } from "react-router-dom"
import { AuthContext } from "../../context/AuthContext";
import DetailProfil from "./detailProfil";
import { useContext } from "react";
import api from "../../api/api";
export default function ProfilMenu({ visible, setVisible, id }) {
    const navigate = useNavigate();
    const { user, logout } = useContext(AuthContext);

    const handleLogout = async () => {
        try {
            await api.post('/logout'); 
        } catch (err) {
            console.error('Erreur lors de la déconnexion :', err);
        } finally {
            logout();
            navigate('/login');
            setVisible(false);
        }
    };

    return (



        <div className="z-10 text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">


            <div className="self-center text-sm text-center text-gray-500 bg-white border border-gray-200 rounded-t-lg dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600">
                <div className="p-3">
                    <div className="flex items-center justify-center mb-2">

                        <img className="rounded-full w-28 h-28" src={user?.picture || `https://robohash.org/${user.email}.png`} alt="Admin" />

                    </div>
                    <div className="text-base font-semibold leading-none text-gray-900 dark:text-white" id={id}>
                        {/* <span>{user?.name || "Nom d'utilisateur"}</span>  /   */}
                        <span className="hover:underline">@{user?.username || "Pseudo"}</span>

                    </div>

                    <p className="mt-2">
                        {user?.email || "email@exemple.com"}
                    </p>
                    <p className="mb-4 text-sm">{user?.role}
                        {/* -  <a href="#" className="text-blue-600 dark:text-blue-500 hover:underline">kln.com</a> */}
                    </p>
                    <div>
                        <button type="button" className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-xs px-3 py-1.5 dark:bg-red-600 dark:hover:bg-red-700 focus:outline-none dark:focus:ring-red-800"
                            onClick={handleLogout}
                        >
                            Deconnexion
                        </button>
                    </div>

                </div>
            </div>

            <button type="button" className="relative inline-flex items-center w-full px-4 py-2 text-sm font-medium border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white"
                onClick={() => navigate('/detailprofil')}>
                <svg className="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                </svg>
                Profile
            </button>


            <button type="button" className="relative inline-flex items-center w-full px-4 py-2 text-sm font-medium border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white"
                onClick={() => { navigate('/parametres/compte'); setVisible(false) }}
            >
                <svg className="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.75 4H19M7.75 4a2.25 2.25 0 0 1-4.5 0m4.5 0a2.25 2.25 0 0 0-4.5 0M1 4h2.25m13.5 6H19m-2.25 0a2.25 2.25 0 0 1-4.5 0m4.5 0a2.25 2.25 0 0 0-4.5 0M1 10h11.25m-4.5 6H19M7.75 16a2.25 2.25 0 0 1-4.5 0m4.5 0a2.25 2.25 0 0 0-4.5 0M1 16h2.25" />
                </svg>
                Settings
            </button>



            

        </div>
    )
}